import React, { useEffect, useState } from "react";
import authApiService from "../../../services/authServices";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Modal from "../../../utils/modalUtils";
import { Link, useNavigate } from "react-router-dom";


const CreateSeason = () => {
    const navigate = useNavigate();
    const [city, setCity] = useState([]);
    const [earlyStartDate, setEarlyStartDate] = useState(null);
    const [earlyEndDate, setEarlyEndDate] = useState(null);
    const [registrationEndDate, setRegistrationEndDate] = useState(null);
    const [isLoading, setIsLoading] = useState(true);
    const [isSaving, setIsSaving] = useState(false);
    const [formData, setFormData] = useState({
        name: "",
        cityId: "",
        earlyStart: "",
        start: "",
        end: "",
        version: 1,
        earlyRegistrationFee: "",
        regularRegistrationFee: "",
        secondEventFee: "",
        thirdEventFee: "",
        playingPreference: [],
        playerLevel: [].map(Number),
        gender: [],
        state: "1",
        season_name: "test_stpl",


    });

    useEffect(() => {
        const fetchCityData = async () => {

            try {
                const response = await authApiService.get("cityDetails");
                if (response && response.data) {
                    setCity(response.data);
                }
            } catch (error) {
                console.error("Error fetching city data:", error);
            }
        };

        fetchCityData();
    }, []);

    const formatDateOnly = (date) => {
        if (!date) return "";
        const year = date.getFullYear();
        const month = String(date.getMonth() + 1).padStart(2, "0");
        const day = String(date.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
    };

    const handleDateChange = (type, date) => {
        if (type === "earlyStart") {
            setEarlyStartDate(date);
            setFormData({ ...formData, earlyStart: formatDateOnly(date) });
        }
        if (type === "earlyEnd") {
            setEarlyEndDate(date);
            setFormData({ ...formData, start: formatDateOnly(date) });
        }
        if (type === "registrationEnd") {
            setRegistrationEndDate(date);
            setFormData({ ...formData, end: formatDateOnly(date) });
        }
    };

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };



    const handleCheckboxChange = (e) => {
        const { name, value, checked } = e.target;

        setFormData((prevData) => {
            let updatedValues = [...(prevData[name] || [])];

            if (checked) {
                updatedValues.push(value);
            } else {
                updatedValues = updatedValues.filter((item) => item !== value);
            }

            return { ...prevData, [name]: updatedValues };
        });
    };

    /**
     * Handles form submission for creating a new season
     * @param {Event} e - The form submit event
     */
    const handleSubmit = async (e) => {
        setIsSaving(true);
        setIsLoading(true);
        e.preventDefault();
        try {
            const response = await authApiService.post("seasonAdd", formData);
            Modal.fire({
                icon: "success",
                title: "Created!",
                text: "Season created successfully!",
                timer: 2000,
                showConfirmButton: false,
                timerProgressBar: true,
                allowOutsideClick: false,
                allowEscapeKey: false,
                confirmButtonColor: "#addd1e"
            }).then(() => {
                navigate("/carter/manageRegistration");
            });
        } catch (error) {
            console.error("Error registering season", error);
            Modal.fire({
                icon: "error",
                title: "Error",
                text: error.response?.data?.message || "Error registering season. Please try again.",
                confirmButtonText: "OK",
                confirmButtonColor: "#addd1e"
            });
        } finally {
            setIsSaving(false);
            setIsLoading(false);
        }
    };
    const CustomHeader = ({
        date,
        changeYear,
        changeMonth,
        decreaseMonth,
        increaseMonth,
        prevMonthButtonDisabled,
        nextMonthButtonDisabled,
    }) => {
        const currentYear = new Date().getFullYear();
        const years = Array.from({ length: currentYear - 2000 + 1 }, (_, i) => 2000 + i);

        const months = [
            "January",
            "February",
            "March",
            "April",
            "May",
            "June",
            "July",
            "August",
            "September",
            "October",
            "November",
            "December",
        ];

        return (
            <div style={{ margin: 10, display: "flex", justifyContent: "center" }}>
                <button onClick={decreaseMonth} disabled={prevMonthButtonDisabled}>
                    {"<"}
                </button>
                <select
                    onChange={(e) => changeYear(parseInt(e.target.value, 10))}
                    value={date.getFullYear()}
                >
                    {years.map((year) => (
                        <option key={year} value={year}>
                            {year}
                        </option>
                    ))}
                </select>
                <select
                    onChange={(e) => changeMonth(parseInt(e.target.value, 10))}
                    value={date.getMonth()}
                >
                    {months.map((month, index) => (
                        <option key={index} value={index}>
                            {month}
                        </option>
                    ))}
                </select>
                <button onClick={increaseMonth} disabled={nextMonthButtonDisabled}>
                    {">"}
                </button>
            </div>
        );
    };




    


    return (
        <div className="page-container col-sm-12 mb-5">
            <div className="card bg-light shadow-sm registration-page p-0 mb-5">
                <form id="registrationForm" method="post" onSubmit={handleSubmit}>
                    <input id="id" name="id" type="hidden" defaultValue="" />
                    <input id="version" name="version" type="hidden" defaultValue="1" />
                    <input
                        id="scheduleState"
                        name="scheduleState"
                        type="hidden"
                        defaultValue={1}
                    />
                    <div className="card-body">
                        <div className="row">
                            <input type="hidden" name="editFlowHidden" id="editFlowHidden" defaultValue="null" />
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">Name</label>
                                    <div class="col-sm-7">
                                        <input type="text" id="displayName" name="name" onChange={handleInputChange} maxLength={50} class="form-control w-100  px-3" value={formData.name} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">City</label>
                                    <div class="col-sm-7">
                                        <select id="city" name="cityId" className="form-select w-100 h34" style={{ width: 115 }} value={formData.cityId} onChange={handleInputChange} >
                                            <option value="">Select City</option>
                                            {city.map((city) => (
                                                <option key={city.id} value={city.id}>{city.name}</option>
                                            ))}
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">Start of Early Registration</label>
                                    <div class="col-sm-7">
                                        <DatePicker
                                        className="form-control w-100 calendar_icon h34 h34 px-3"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="DD-MM-YYYY"
                                        selected={earlyStartDate}
                                        onChange={(date) => handleDateChange("earlyStart", date)} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">End of Early Registration</label>
                                    <div class="col-sm-7">
                                        <DatePicker
                                        className="form-control w-100 calendar_icon h34 h34 px-3"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="DD-MM-YYYY"
                                        selected={earlyEndDate}
                                        onChange={(date) => handleDateChange("earlyEnd", date)}
                                        minDate={earlyStartDate || new Date()}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">End of Registration</label>
                                    <div class="col-sm-7">
                                        <DatePicker
                                        className="form-control w-100 calendar_icon h34 h34 px-3"
                                        dateFormat="dd-MM-yyyy"
                                        placeholderText="DD-MM-YYYY"
                                        selected={registrationEndDate}
                                        onChange={(date) => handleDateChange("registrationEnd", date)}
                                        minDate={earlyEndDate || new Date()}
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label"> Early Registration Fee</label>
                                    <div class="col-sm-7">
                                        <input id="earlyRegistrationFee" name="earlyRegistrationFee" className="form-control w-100 h34 h34 px-3" type="text" value={formData.earlyRegistrationFee} onChange={handleInputChange} maxLength={20} />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">  Regular Registration Fee <span className="req">*</span></label>
                                    <div class="col-sm-7 d-flex align-items-center">
                                        ($) <input id="regularRegistrationFee" name="regularRegistrationFee" className="form-control w-100 h34 h34 px-3 ml-1" type="text" value={formData.regularRegistrationFee} onChange={handleInputChange} maxLength={20} required />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">  Second Event Fee <span className="req">*</span></label>
                                    <div class="col-sm-7 d-flex align-items-center">
                                        ($) <input id="secondEventFee" name="secondEventFee" className="form-control w-100 h34 h34 px-3 ml-1" type="text" value={formData.secondEventFee} onChange={handleInputChange} maxLength={20} required />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">   Third Event Fee <span className="req">*</span></label>
                                    <div class="col-sm-7 d-flex align-items-center">
                                        ($) <input id="thirdEventFee" name="thirdEventFee" className="form-control w-100 h34 h34 px-3 ml-1" type="text" value={formData.thirdEventFee} onChange={handleInputChange} maxLength={20} required />
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label"> Playing Preference</label>
                                    <div class="col-sm-7">
                                        <div class="form-check form-check-inline">
                                            <input id="singles" class="form-check-input" name="playingPreference" type="checkbox" value="Singles" onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">Singles</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input id="doubles" class="form-check-input" name="playingPreference" type="checkbox" value="Doubles" onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">Doubles</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input id="mixedDoubles" class="form-check-input" name="playingPreference" type="checkbox" value="Mixed Doubles" onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">Mixed Doubles</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label"> Player Level</label>
                                    <div class="col-sm-7">
                                        <div class="form-check form-check-inline">
                                            <input id="2_5" class="form-check-input" name="playerLevel" type="checkbox" value={2.5} onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">2.5 </label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input id="3_0" class="form-check-input" name="playerLevel" type="checkbox" value={3.0} onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">3.0</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input id="3_5" class="form-check-input" name="playerLevel" type="checkbox" value={3.5} onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">3.5</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input id="4_0" class="form-check-input" name="playerLevel" type="checkbox" value={4.0} onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">4.0</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input id="4_5" class="form-check-input" name="playerLevel" type="checkbox" value={4.5} onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">4.5</label>
                                        </div>
                                        <div class="form-check form-check-inline">
                                            <input id="5_0" class="form-check-input" name="playerLevel" type="checkbox" value={5.0} onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">5.0</label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12">
                                <div class="mb-3 row">
                                    <label class="col-sm-5 col-form-label">  Gender</label>
                                    <div class="col-sm-7">
                                        <div class="form-check form-check-inline">
                                            <input id="male" class="form-check-input" name="gender" type="checkbox" value="M" onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">Male </label>
                                        </div>
                                        <div class="form-check form-check-inline">

                                            <input id="female" class="form-check-input" name="gender" type="checkbox" value="F" onChange={handleCheckboxChange} />
                                            <label class="form-check-label w-100" for="singles">Female</label>
                                        </div>

                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-12 buttonBar bottom">
                                <input type="submit" className="green_btn mr-2" name="save" value="Save" />
                                {/* <input type="button" className="button" name="cancel"
                                    onClick={() => {
                                        document.getElementById('bCancel').value = 'true';
                                        document.getElementById('registrationForm').submit();
                                    }}
                                    value="Cancel"
                                /> */}

                                
                                {/* <button type="cancle" className="gray_btn"
                                    onClick={() => {

                                        navigate("/carter/manageRegistration");
                                    }}>
                                    cancle
                                </button> */}

                                <Link to = "/carter/manageRegistration" className="gray_btn">cancel</Link> 

                                <input type="hidden" name="bCancel" id="bCancel" defaultValue="false" />
                            </div>
                        </div>
                    </div>
                    <ul>
                    </ul>
                </form>
            </div>
        </div>
    );
};

export default CreateSeason; 
